import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import { getApiTokensInLocalStorage } from '../../services/localStorage/localStorage';

const PublicRouteLayout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const isAuthenticated = getApiTokensInLocalStorage();
    if (isAuthenticated) {
      navigate(`/lead`);
    }
  }, [navigate]);

  return <Outlet />;
};

export default PublicRouteLayout;
